/*
 * 消費税関連の関数
 */
import { CONSUMPTION_TAX_RATE } from '@/utils/constants/tax/tax';
/**
 * 消費税の計算（内税）
 * @param value
 * @returns {number}
 */
export const calcIncludingTax = (value) => {
    const v = typeof value === 'string' ? parseInt(value, 10) : value;
    return Math.floor(v * (1 + CONSUMPTION_TAX_RATE));
};
